import { SweetFacePagedResponse } from './sweet-face-paged-response';
import { SweetFaceTerminalDto } from './sweet-face-terminal.dto';

export class GetSweetFaceTerminalsResponseDto extends SweetFacePagedResponse<SweetFaceTerminalDto> {}
